var _rect, _rect2, _g, _path, _rect3, _g2, _path2, _path3, _rect4, _g3, _path4, _path5, _circle, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEjectButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.9563,
    y: 22.2025,
    width: 13.5238,
    height: 24.2302,
    rx: 6.7619,
    transform: "rotate(-90 8.9563 22.2025)",
    fill: "#003E6B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8036_69292",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 22,
    height: 11
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.6467,
    y: 20.5121,
    width: 10.1429,
    height: 20.8492,
    rx: 5.07143,
    transform: "rotate(-90 10.6467 20.5121)",
    fill: "#99DFF9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8036_69292)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.0833,
    y: 21.4513,
    width: 12.0212,
    height: 22.5397,
    rx: 6.01058,
    transform: "rotate(-90 10.0833 21.4513)",
    fill: "#003E6B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.6467,
    y: 19.3851,
    width: 11.2698,
    height: 20.8492,
    rx: 5.63492,
    transform: "rotate(-90 10.6467 19.3851)",
    fill: "#003E6B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.6467,
    y: 11.4962,
    width: 11.2698,
    height: 20.8492,
    transform: "rotate(-90 10.6467 11.4962)",
    fill: "#F2FBFE"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.67568 17.9346C5.31562 18.2713 4.7273 18.016 4.7273 17.5231L4.7273 13.2335C4.7273 12.7608 5.27436 12.4981 5.64322 12.7938L7.89066 14.5953L7.89066 15.8632L5.67568 17.9346Z",
    fill: "#003E6B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8036_69292",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 13,
    width: 3,
    height: 4
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.29663,
    y: 13.7501,
    width: 2.95833,
    height: 1.40593,
    rx: 0.702965,
    transform: "rotate(90 9.29663 13.7501)",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8036_69292)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9.29663,
    y: 13.7501,
    width: 2.95833,
    height: 1.40593,
    rx: 0.702965,
    transform: "rotate(90 9.29663 13.7501)",
    fill: "#003E6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.27821 13.3275C8.46189 13.3275 8.6195 13.4563 8.64721 13.6379C8.69889 13.9766 8.76929 14.5606 8.76929 15.2293C8.76929 15.898 8.69889 16.482 8.64721 16.8207C8.6195 17.0023 8.46189 17.1311 8.27821 17.1311C8.06413 17.1311 7.89057 16.9575 7.89057 16.7434L7.89057 13.7152C7.89057 13.5011 8.06413 13.3275 8.27821 13.3275Z",
    fill: "#003E6B"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.1213 17.6063C3.74789 17.779 3.32129 17.5063 3.32129 17.0949L3.32129 13.7142C3.32129 13.3218 3.7123 13.0496 4.0803 13.1857L7.8906 14.5954L7.8906 15.8632L4.1213 17.6063Z",
    fill: "#003E6B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4471 17.9585C36.7995 18.322 37.4153 18.0726 37.4153 17.5663L37.4153 12.7468C37.4153 12.2613 36.8422 12.003 36.4785 12.3247L34.2519 14.2941L34.2519 15.6932L36.4471 17.9585Z",
    fill: "#003E6B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_8036_69292",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 13,
    width: 3,
    height: 4
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 3.26437,
    height: 1.40593,
    rx: 0.702965,
    transform: "matrix(3.40963e-08 1 1 -5.58963e-08 32.8459 13.3615)",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_8036_69292)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.26437,
    height: 1.40593,
    rx: 0.702965,
    transform: "matrix(3.40963e-08 1 1 -5.58963e-08 32.8459 13.3615)",
    fill: "#003E6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8677 12.8951C33.6829 12.8951 33.5251 13.0265 33.4993 13.2095C33.4473 13.5785 33.3733 14.237 33.3733 14.9937C33.3733 15.7504 33.4473 16.4088 33.4993 16.7778C33.5251 16.9608 33.6829 17.0922 33.8677 17.0922C34.0799 17.0922 34.252 16.9201 34.252 16.7079L34.252 13.2795C34.252 13.0672 34.0799 12.8951 33.8677 12.8951Z",
    fill: "#003E6B"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0017 17.6065C38.3766 17.7979 38.8213 17.5255 38.8213 17.1046L38.8213 13.2674C38.8213 12.867 38.4155 12.5944 38.0448 12.7457L34.252 14.2941L34.252 15.6931L38.0017 17.6065Z",
    fill: "#003E6B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2974 12.5615L19.8586 12.5615L19.8586 13.6907L23.1111 13.6907C22.8474 13.3121 22.7933 12.8793 22.7797 12.4263L23.3072 12.4263C23.3275 13.0078 23.5033 13.4135 23.8955 13.7178L23.8955 14.2858L19.8586 14.2858L19.8586 15.415L19.2974 15.415L19.2974 12.5615Z",
    fill: "#003E6B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 32,
    r: 7,
    fill: "#ED3431",
    stroke: "#ED3431",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33 33.4142L35.8284 36.2426L37.2427 34.8284L34.4142 32L37.2427 29.1716L35.8284 27.7574L33 30.5858L30.1716 27.7574L28.7574 29.1716L31.5858 32L28.7574 34.8284L30.1716 36.2426L33 33.4142Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEjectButton);
export default __webpack_public_path__ + "static/media/eject_Button.abff1091e7fc918dea6d760aa2a47186.svg";
export { ForwardRef as ReactComponent };